<div class="callback-container">
  <div class="message">Autenticando...</div>
  <div class="loader-container">
    <div class="loader loader-contained"></div>
  </div>
</div>